import React from 'react';
import { Route, Switch } from 'react-router-dom';

import {DocxPage, PptxPage} from './pages/ManualPage';
import urls, { manualPptxUrl,manualUrl } from './urls';

const ManualRoute = () => {
  return (
    <Switch>
      <Route exact path={manualPptxUrl()} component={PptxPage} />
      <Route exact path={manualUrl()} component={DocxPage} />
    </Switch>
  );
}

export const baseUrl = urls.base;

export default ManualRoute;
